import React from "react";
import { Star } from "lucide-react";

export const StarRating = ({ value = 0, size = 16, onChange, className = "" }) => {
  const interactive = typeof onChange === "function";
  return (
    <div className={`flex items-center gap-0.5 ${className}`} role={interactive ? "radiogroup" : undefined}>
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = n <= Math.round(value);
        const Icon = (
          <Star
            style={{ width: size, height: size }}
            className={filled ? "fill-amber-400 text-amber-400" : "fill-transparent text-slate-300"}
          />
        );
        return interactive ? (
          <button key={n} type="button" onClick={() => onChange(n)} data-testid={`star-${n}`} className="transition-transform hover:scale-110">
            {Icon}
          </button>
        ) : (
          <span key={n}>{Icon}</span>
        );
      })}
    </div>
  );
};
